import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'

/**
 * 全部：ALL
 * 客户：基本信息、联系人、客户、门点信息、特殊要求、开票要求、信用账款、合同约号、文件资料、电商用户
 * 订舱代理：基本信息、联系人、信用账款、合同约号、文件资料、舱位承运人（可维护）
 * 目的港代理：基本信息、联系人、信用账款、合同约号、文件资料、目的港代理、目的港指定货代理、所在港口
 * 船公司：基本信息、联系人、信用账款、合同约号、文件资料、EDI配置、舱位代理
 * 船空公司：基本信息、联系人、信用账款、合同约号、文件资料、航空公司、舱位代理
 * 报关行：基本信息、联系人、信用账款、合同约号、文件资料
 * 车队：基本信息、联系人、信用账款、合同约号、文件资料
 * 仓库：基本信息、联系人、信用账款、合同约号、文件资料、仓库信息
 * 其它：基本信息、联系人、信用账款、合同约号、文件资料
 */
export function getSearchConditionDropList(code) {
  let conditions = []
  switch (code) {
    case PartnerServiceItem.PARTNER_SERVICE_ALL.code:
      conditions = [...PartnerServiceItem.PARTNER_SERVICE_ITEMS]
      break
    case PartnerServiceItem.PARTNER_BOOKING.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_BOOKING_ALL)
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_BOOKING_AGENT)
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_SEA_CMP_AGENT)
      break
    case PartnerServiceItem.SHIPPING_COMPANY.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_SEA_CMP)
      break
    case PartnerServiceItem.AIRLINE_COMPANY.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_AIR_CMP)
      break
    case PartnerServiceItem.PARTNER_AGENT.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_AGENT_ALL)
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_OVERSEA_AGENT)
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_DESIGNATION_AGENT)
      break
    case PartnerServiceItem.PARTNER_CUSTOMER.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_CUSTOMER)
      break
    case PartnerServiceItem.PARTNER_CUSTOMS_BROKER.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_CUSTOMS_BROKER)
      break
    case PartnerServiceItem.PARTNER_WAREHOUSE.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_WAREHOUSE)
      break
    case PartnerServiceItem.PARTNER_TRUCK.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_TRUCK_CMP)
      break
    case PartnerServiceItem.PARTNER_OTHER.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_OTHER)
      break
    case PartnerServiceItem.PARTNER_COMPANY_FACTORY_MANUFACTURER.code:
      conditions.push(PartnerServiceItem.PARTNER_COMPANY_FACTORY_MANUFACTURER)
      break
    case PartnerServiceItem.PARTNER_SETTLEMENT_AGENT.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_SETTLEMENT_AGENT)
      break
    case PartnerServiceItem.PARTNER_SUPPLY_CHAIN.code:
      conditions.push(PartnerServiceItem.PARTNER_SERVICE_ALL)
      conditions.push(PartnerServiceItem.PARTNER_COMPANY_VENDOR)
      conditions.push(PartnerServiceItem.PARTNER_COMPANY_MIDDLEMAN)
      conditions.push(PartnerServiceItem.PARTNER_COMPANY_FACTORY)
      break
  }
  return conditions
}

export function checkServiceGroupVisible(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code || serviceType === PartnerServiceItem.PARTNER_BOOKING.code || serviceType == PartnerServiceItem.PARTNER_AGENT.code
}

/**
 * Tab 客户
 */
export function checkTabCustomer(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 供应链线路
 */
export function checkSupplyChain(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 订舱
 */
export function checkTabBooking(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_BOOKING.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 代理
 */
export function checkTabAgent(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_AGENT.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 报关
 */
export function checkTabCustomsBroker(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_CUSTOMS_BROKER.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 仓储
 */
export function checkTabWarehouse(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_WAREHOUSE.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 运输
 */
export function checkTabTruck(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_TRUCK.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 其他
 */
export function checkTabOther(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_OTHER.code || serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * Tab 其他
 */
export function checkTabALL(serviceType) {
  return serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code
}

/**
 * 新增时默认值
 * 订舱：订舱代理，船公司，航空公司
 * 报关：报关行
 * 仓储：仓库
 * 运输：车队
 * 其它：其它
 * 客户：客户
 * 代理：目的港代理，指定货代理
 */
export function changeCompanyServiceItem(serviceType, company) {
  switch (serviceType) {
    case PartnerServiceItem.PARTNER_BOOKING.code:
      company.isBookingAgent = true
      break
    case PartnerServiceItem.SHIPPING_COMPANY.code:
      company.isSeaCmp = true
      break
    case PartnerServiceItem.AIRLINE_COMPANY.code:
      company.isAirCmp = true
      break
    case PartnerServiceItem.PARTNER_AGENT.code:
      company.isOverseaAgent = true
      company.isDesignationAgent = true
      break
    case PartnerServiceItem.PARTNER_CUSTOMER.code:
      company.isCustomer = true
      break
    case PartnerServiceItem.PARTNER_CUSTOMS_BROKER.code:
      company.isCustomsBroker = true
      break
    case PartnerServiceItem.PARTNER_WAREHOUSE.code:
      company.isWarehouse = true
      break
    case PartnerServiceItem.PARTNER_TRUCK.code:
      company.isTruckCmp = true
      break
    case PartnerServiceItem.PARTNER_OTHER.code:
      company.isOther = true
      break
  }
}
